// src/mixins/aplicaPagoMixin.js
export default {
  data() {
    return {
      dialogPagoShow: false,
      selectedPago: {},
      dialogErrorDesc: false,
      ErrorDesc: ''
    };
  },
  methods: {
    async ValidaAplicacion(idtarjeta, recibo) {
      return await this.$http.get(
        `payment/validaAplicacion?idtarjeta=${idtarjeta}&recibo=${recibo}`
      );
    },
    async openModalPago(item) {
      this.selectedPago = { ...item };
      console.log(this.selectedPago)
      try {
        const response = await this.ValidaAplicacion(this.selectedPago.contrato, this.selectedPago.idpago);
        console.log(response.data)
        if (response.data === 0) {
          this.dialogPagoShow = true;
        } else {
          this.ErrorDesc = `Se tienen ${response.data} recibos anteriores pendientes de pago.`;
          this.dialogErrorDesc = true;
        }
      } catch {
        this.ErrorDesc = 'No se pudo validar el pago, intenta más tarde.';
        this.dialogErrorDesc = true;
      }
    }
  }
};